import { render, staticRenderFns } from "./MenuPopup.vue?vue&type=template&id=b62ffcb8&scoped=true&"
import script from "./MenuPopup.vue?vue&type=script&lang=js&"
export * from "./MenuPopup.vue?vue&type=script&lang=js&"
import style0 from "./MenuPopup.vue?vue&type=style&index=0&id=b62ffcb8&scoped=true&lang=css&"
import style1 from "./MenuPopup.vue?vue&type=style&index=1&id=b62ffcb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62ffcb8",
  null
  
)

export default component.exports